import React from "react";
import { DataTable } from "@sscs/ui";
import Signature from "./signature/Signature";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "identity",
        label: "Identity",
        sortProperty: "identity",
        sortId: "signatures-sort-identity",
        width: "60%",
    },
    { id: "serial", label: "Serial", width: "40%" },
    {
        id: "valid_for",
        label: "Valid for",
        sortProperty: "valid_to",
        sortId: "signatures-sort-valid-for",
        startReverse: true,
        width: "200px",
    },
    {
        id: "issues",
        label: "Issues",
        sortProperty: "violations",
        sortId: "signatures-sort-issues",
        startReverse: true,
        width: "100px",
    },
    {
        id: "files_signed",
        label: "# Files signed",
        sortProperty: "files_signed",
        sortId: "signatures-sort-files-signed",
        startReverse: true,
        width: "160px",
    },
];
const SignatureTable = ({ signatures, sort, searchRegex, filters, onSortChange, status, itemCount, pagination, onPaginationChange, }) => {
    return (React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: onSortChange, status: status, empty: { subject: "signatures", filters }, pagination: {
            id: "signatures-pagination",
            itemCount,
            pagination,
            onChange: onPaginationChange,
        } }, signatures.map((signature, index) => (React.createElement(Signature, { key: signature.thumbprint, signature: signature, searchRegex: searchRegex, index: index })))));
};
export default SignatureTable;
//# sourceMappingURL=SignatureTable.js.map